import {
    OfficeTypeData,
    OfficeTypeStatus,
    OfficeTypeUpdateForm,
    OfficeTypeCreateForm,
    OfficeTypeResponse,
    OfficeTypeListResponse,
} from 'chaika-frontend-types/frontend-cms';

import { axios } from '@lib/axios';

const BASE_URL = '/api/office-type';

export class OfficeTypeApi {
    public static async create(officeType: OfficeTypeCreateForm): Promise<void> {
        await axios.post(`${BASE_URL}`, { officeType });
    }

    public static async update(id: string, officeType: OfficeTypeUpdateForm): Promise<void> {
        await axios.put(`${BASE_URL}/${id}`, { officeType });
    }

    public static async updateStatus(id: string, status: OfficeTypeStatus): Promise<void> {
        await axios.put(`${BASE_URL}/${id}/status`, { officeType: { status } });
    }

    public static async getList(): Promise<OfficeTypeData[]> {
        const res = await axios.get<OfficeTypeListResponse>(`${BASE_URL}`);

        return res.data.officeTypes;
    }

    public static async getById(id: string): Promise<OfficeTypeData> {
        const res = await axios.get<OfficeTypeResponse>(`${BASE_URL}/${id}`);

        return res.data.officeType;
    }
}
